import { render, staticRenderFns } from "./ManageNotificationList.vue?vue&type=template&id=caaaccc4&scoped=true"
import script from "./ManageNotificationList.vue?vue&type=script&lang=js"
export * from "./ManageNotificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaaccc4",
  null
  
)

export default component.exports